import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import Axios from "../../services/axios";

export const getPatientDoctorNotesData = createAsyncThunk(
  "notes/getPatientDoctorNotesData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/emr/getDoctorNotesByPatientId`, payload);
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to fetch doctor notes"
      );
      return rejectWithValue(error.response?.data || "Failed to fetch doctor notes");
    }
  }
);

const initialState = {
  isLoading: false,
  patientDoctorNotes: null,
};

const NotesSlice = createSlice({
  name: "notes",
  initialState,
  reducers: {
    clearNotesData: (state) => {
      state.patientDoctorNotes = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPatientDoctorNotesData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPatientDoctorNotesData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.patientDoctorNotes = action.payload;
      })
      .addCase(getPatientDoctorNotesData.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { clearNotesData } = NotesSlice.actions;
export default NotesSlice.reducer;
